import React from "react";
import { FaqResourcePage } from "../components/FaqResourcePage";
import { CALENDLY_URL, EXPERT_WITNESS_FAQ_SECTIONS } from "../data/content";

const ExpertWitnessFaq = () => (
  <FaqResourcePage
    pageTestId="expert-witness-faq-page"
    kicker="Expert Witness FAQs"
    h1Lines={[
      <span key="a">Expert witness services —</span>,
      <span key="b">
        your questions <em className="italic text-[#3E9BDC]">answered.</em>
      </span>,
    ]}
    intro={
      <>
        Expert work is most useful when the assignment, source materials and boundaries are clear. These
        answers address common questions from counsel and parties considering independent expert analysis
        in arbitration and other legal proceedings involving the investment and insurance industries.
        American Elm Advisors provides independent expert analysis within an agreed scope. We begin with a
        conflict check and preliminary discussion, then work through counsel to define the engagement,
        materials, timing and deliverables.
      </>
    }
    primaryCta={{ label: "Inquire about expert witness services", to: "/expert-witness-intake" }}
    sections={EXPERT_WITNESS_FAQ_SECTIONS}
    inlineCta={{
      afterSectionId: "engagement-through-counsel",
      body: "Considering an independent expert? Request a confidential conflict check and preliminary discussion.",
      buttonLabel: "Discuss your matter",
      to: "/expert-witness-intake",
      eventName: "faq_inline_expert",
    }}
    closing={{
      heading: "Inquire about expert witness services.",
      body: "Contact us to discuss your matter confidentially and determine whether an independent expert engagement may be appropriate.",
      primary: { label: "Start pre-retention intake", to: "/expert-witness-intake" },
      secondary: { label: "Schedule a 15-minute call", to: CALENDLY_URL, external: true },
    }}
    related={[
      { label: "Compliance consulting", to: "/compliance-consulting" },
      { label: "AML independent audits", to: "/aml-independent-audits" },
      { label: "Capital markets consulting", to: "/capital-markets-consulting" },
    ]}
  />
);

export default ExpertWitnessFaq;
